<script setup lang="ts">
import { useInputStore } from '@/PC/store/inputStore'
import { storeToRefs } from 'pinia'

const inputStore = useInputStore()
const { lang } = storeToRefs(inputStore)
</script>

<template>
  <div class="lang-switch">
    <span class="lang-label" :class="{ active: lang === 'ja' }" @click="inputStore.setLang('ja')">JA</span>
    <span class="lang-label" :class="{ active: lang === 'en' }" @click="inputStore.setLang('en')">EN</span>
  </div>
</template>

<style scoped>
.lang-switch {
  display: flex;
  border: 1px solid var(--border-gray-1, #ddd);
  border-radius: 4px;
  overflow: hidden;
}
.lang-label {
  padding: 2px 8px;
  font-size: 12px;
  font-weight: bold;
  color: var(--font-gray-2);
  background: var(--bg-gray-1, #f0f0f0);
  cursor: pointer;
  user-select: none;
}
.lang-label.active {
  color: #fff;
  background: var(--main);
}
.lang-label:not(.active):hover {
  background: var(--bg-gray-2, #e0e0e0);
}
</style>
